<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="edit-container-sidebar items-no-padding" spacer v-model="sidebarActive">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Editar Firma Masiva</h4>
        <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <div class="p-6 scroll-area--data-list-add-new">
      <div class="mb-5">
        <vs-input 
          label="Nombre de la Firma Masiva" 
          v-model="containerName" 
          class="w-full" 
          placeholder="Ej. Documentos Enero 2025"
        />
        <span v-if="error" class="text-danger text-sm">{{ error }}</span>
      </div>

    </div>

    <div class="flex flex-wrap items-center p-6 border-t" slot="footer">
      <vs-button class="mr-6 shadow-md" @click="submitEdit" :disabled="!containerName">Guardar Cambios</vs-button>
      <vs-button type="border" color="danger" @click="closeSidebar">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
export default {
  name: 'EditContainer',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    container: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      containerName: '',
      error: null
    }
  },
  watch: {
    active(val) {
      if (val && this.container) {
        this.containerName = this.container.name
      }
    }
  },
  computed: {
    sidebarActive: {
      get() {
        return this.active
      },
      set(val) {
        if (!val) {
          this.closeSidebar()
        }
      }
    }
  },
  methods: {
    submitEdit() {
      if (!this.containerName.trim()) {
        this.error = 'El nombre es requerido.'
        return
      }
      this.error = null

      this.$vs.loading()
      
      const payload = {
          uuid: this.container.uuid,
          data: {
              name: this.containerName
          }
      }

      this.$store.dispatch('containerManagement/updateContainer', payload)
        .then(() => {
            this.$vs.loading.close()
            this.$vs.notify({
                title: 'Éxito',
                text: 'Firma masiva actualizada correctamente.',
                color: 'success',
                position: 'top-center',
                time: 3000
            });
            this.$emit('edit-success')
            this.closeSidebar()
        })
        .catch(error => {
            this.$vs.loading.close()
            const message = (error && error.toString()) || 'Error al actualizar la firma masiva';
            this.$vs.notify({
                title: 'Error',
                text: message.replace(/ON_HOLD/g, 'En espera'),
                color: 'danger',
                position: 'top-center',
                time: 3000
            });
        })
    },
    closeSidebar() {
      this.containerName = ''
      this.error = null
      this.$emit('close')
    },
    uploadDocument() {
    },
    uploadMassive() {
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-container-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.scroll-area--data-list-add-new {
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
  overflow-y: auto;
}
</style>
